/* ==========================================================================
   PWR COMMUNITY
   ----------------------------------------------------------------------------
   Section controller for "Our Community".

   IMPORTANT — READ BEFORE ADDING CODE:
   This section is presentational. Its interactions (hover zoom, overlay
   reveal, caption fade) are ALL CSS :hover in pwr-community.css, guarded by
   @media (hover: hover) so touch devices use tap-to-navigate only. The
   fade / scale / cascade animations are owned by the PWR Animation Engine via
   [data-pwr-reveal] / [data-pwr-reveal-group], auto-scanned on load and on
   shopify:section:load. Video tiles are poster image + link (no autoplay, no
   embed, no external feed). There is therefore NO behaviour to implement here
   — doing so would duplicate CSS / the engine and violate the reuse rules.

   It exists as a registered lifecycle seam for section-shape consistency and
   as a hook for future interactivity (e.g. a lightbox). Registered via
   PWR.registerSection => Theme Editor safe, no duplicate init. init() no-op.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var Section = PWR.Section;

  function Community(root) {
    Section.call(this, root);
  }
  Community.prototype = Object.create(Section.prototype);
  Community.prototype.constructor = Community;

  /* No behaviour: hover is CSS, reveal is engine-owned, video is a link.
     Intentionally empty. Add future interactivity here; use this.addCleanup(). */
  Community.prototype.init = function () {};

  PWR.registerSection('pwr-community', function (root) { return new Community(root); });
})();
